import { IconButton } from "@chakra-ui/react";
import React from "react";
import AddIcon from "../../../shared/icons/AddIcon";

export const AddButton = (props: Omit<React.ComponentProps<typeof IconButton>, "aria-label">) => (
  <IconButton
    aria-label="Add"
    borderColor="gray.300"
    borderStyle="dashed"
    icon={<AddIcon fontSize="sm" />}
    variant="outline"
    {...props}
  />
);
